import sizeMe from "react-sizeme";
import React from "react";
import PropTypes from "prop-types";
import IconListIcon from "./nounproject-iconlist-icon";
require("../../sass/components/nounproject-iconlist.sass");

class IconList extends React.Component {
    static defaultProps = {
        dragAndDrop: true,
        maxIcons: 36
    };
    static propTypes = {
        dragAndDrop: PropTypes.bool.isRequired,
        maxIcons: PropTypes.number.isRequired
    };

    render() {
        let icons = this.renderIcons();

        return (
            <div
                className={`nounproject-iconlist ${
                    this.props.maxIcons > 13 ? "container" : ""
                } row`}
            >
                <div
                    className="icon-list-header display-flex"
                    style={{ display: "none" }}
                >
                    <div className="icon-list-header-heading">Starter Pack</div>
                    <div className="icon-list-header-sub-heading">
                        100 icons
                    </div>
                </div>
                {icons}
            </div>
        );
    }

    renderIcons() {
        let key = 0,
            iconColumnClass = "col-lg-1 col-md-1 col-sm-2 col-xs-3",
            icons = [],
            iconSize = { width: "42px", height: "42px" },
            totalIcons = this.props.maxIcons;

        if (this.props.iconSize === "84") {
            if (this.props.size.width > 400) {
                // set icon to be 84px if the container is wider than 400
                iconSize = { width: "84px", height: "84px" };
            }
        }

        if (totalIcons === 12) {
            iconColumnClass = "col-lg-2 col-md-2 col-sm-3 col-xs-3";
        }

        if (totalIcons === 6) {
            iconColumnClass = "col-lg-4 col-md-4 col-xs-4";
        }
        while (totalIcons > key) {
            icons.push(
                <div key={key} className={iconColumnClass}>
                    <div className="Grid-cell empty" style={iconSize} />
                </div>
            );
            key = key + 1;
        }

        if (this.props.icons.length > 0) {
            icons = [];
            this.props.icons.forEach(icon => {
                icons.push(
                    <div
                        key={`loaded-icon.${icon.id}`}
                        className={iconColumnClass}
                    >
                        <IconListIcon
                            icon={icon}
                            size={iconSize}
                            dragAndDrop={this.props.dragAndDrop}
                            store={this.props.store}
                        />
                    </div>
                );
            });
        }

        return icons;
    }
}

export default sizeMe()(IconList);
